import { observer } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 77322, offsets 504114:505072. Structure and names inferred from code, not screenshots.
import * as React from "react";
import * as TrackerModule from "./tracker.js";
import * as CookiePreferencesModule from "../state/cookiePreferences.js";
let l = (0, React.createContext)(undefined),
  s = {
    track: () => {},
    setCookiePreference: () => {},
  };
function useAnalytics() {
  return (0, React.useContext)(l) ?? s;
}
let AnalyticsProvider = observer(({ children: children }) => {
  let [t, i] = (0, React.useState)(0);
  (0, React.useEffect)(
    () =>
      (0, CookiePreferencesModule.subscribePreferences)(() => {
        i((e) => e + 1);
      }),
    [],
  );
  let a = (0, React.useCallback)(() => {
      ((0, TrackerModule.ensureTracker)(),
        (0, TrackerModule.initializeTracker)());
    }, []),
    s = (0, React.useCallback)(() => {
      (0, TrackerModule.disableTracker)();
    }, []),
    c = (0, React.useCallback)(
      (e, ...t) => {
        (0, CookiePreferencesModule.getCookiePreferences)().analytical &&
          ((0, TrackerModule.isTrackerInitialized)() || a(),
          (0, TrackerModule.track)(e, ...t));
      },
      [a],
    );
  (0, React.useEffect)(() => {
    (0, CookiePreferencesModule.getCookiePreferences)().analytical &&
      c("login");
  }, [t, c]);
  let u = (0, React.useCallback)(
      (e) => {
        let t = (0, CookiePreferencesModule.getCookiePreferences)(),
          i = {
            ...e,
            valid: true,
          };
        ((0, CookiePreferencesModule.trackPreferenceChange)(t, e),
          (0, CookiePreferencesModule.setCookiePreferences)(i),
          t.analytical !== e.analytical && (e.analytical ? a() : s()));
      },
      [a, s],
    ),
    p = (0, React.useMemo)(
      () => ({
        track: c,
        setCookiePreference: u,
      }),
      [c, u],
    );
  return (
    (0, React.useEffect)(() => {
      (0, CookiePreferencesModule.getCookiePreferences)().analytical &&
        !(0, TrackerModule.isTrackerInitialized)() &&
        a();
    }, []),
    (<l.Provider value={p}>{children}</l.Provider>)
  );
});
export { AnalyticsProvider, useAnalytics };
